
import { FormControl, Box, FormHelperText, TextField } from '@mui/material';
import type { TextFieldProps } from '@mui/material';

interface ChatNameFieldProps extends Omit<TextFieldProps, 'value' | 'onChange' | 'error'> {
  value: string;
  error: string | false;
  setValue: (value: string) => void;
  setError: (error: string | false) => void;
  onSubmit?: () => void;
}

export default function ChatNameField({
  value,
  error,
  setValue,
  setError,
  onSubmit,
  ...rest
}: ChatNameFieldProps) {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value: newValue } = event.target;
    setValue(newValue);
    if (/[#^$<>+%!`&*'"|{}?/\\:=@]/.test(newValue)) {
      setError('Name cannot contain #^$<>+%!`&*\'"|{}?/\\:=@');
    } else if (newValue === '') {
      setError('Name cannot be blank');
    } else {
      setError(false);
    }
  };

  return (
    <Box>
      <FormControl fullWidth>
        <TextField
          {...rest}
          label='Name'
          id='name'
          aria-describedby='name-helper-text'
          onChange={handleChange}
          error={Boolean(error)}
          value={value}
          variant='standard'
        />
        {error ? (
          <FormHelperText id='name-helper-text'>{error}</FormHelperText>
        ) : (
          <FormHelperText id='name-helper-text'>
            Enter the name of the chat.
          </FormHelperText>
        )}
      </FormControl>
    </Box>
  );
}

